import React from "react";

function RescheduleTodayIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 72 72"
    >
      <g data-name="Layer 25">
        <path
          fill="#eac7d4"
          d="M4 18h64v39.55A4.45 4.45 0 0163.55 62H8.45A4.45 4.45 0 014 57.55V18z"
          data-original="#eac7d4"
        ></path>
        <path
          fill="#fbdace"
          d="M25 22h22v40H25z"
          data-original="#fbdace"
        ></path>
        <circle
          cx="53"
          cy="53"
          r="15"
          fill="#f8b989"
          data-original="#f8b989"
        ></circle>
        <path
          fill="#fff"
          d="M58 45L45 58v3h3l13-13z"
          data-original="#ffffff"
        ></path>
        <path
          fill="#994363"
          d="M4 22h64v-7.609A4.391 4.391 0 0063.609 10H8.39A4.391 4.391 0 004 14.391z"
          data-original="#994363"
        ></path>
        <path
          fill="#f8b989"
          d="M17 11h3V7a3 3 0 00-6 0v6a3 3 0 003 3zm19 0h3V7a3 3 0 00-6 0v6a3 3 0 003 3zm19 0h3V7a3 3 0 00-6 0v6a3 3 0 003 3z"
          data-original="#f8b989"
        ></path>
        <g fill="#422661">
          <path
            d="M64 9h-5V7a4 4 0 00-8 0v2H40V7a4 4 0 00-8 0v2H21V7a4 4 0 00-8 0v2H8a5.006 5.006 0 00-5 5v44a5.006 5.006 0 005 5h28a1 1 0 000-2H26V23h20v12a1 1 0 002 0V22a1 1 0 00-1-1H5v-7a3.003 3.003 0 013-3h5v2a4.004 4.004 0 004 4 1 1 0 000-2 2.002 2.002 0 01-2-2V7a2 2 0 014 0v3a1 1 0 001 1h12v2a4.004 4.004 0 004 4 1 1 0 000-2 2.002 2.002 0 01-2-2V7a2 2 0 014 0v3a1 1 0 001 1h12v2a4.004 4.004 0 004 4 1 1 0 000-2 2.002 2.002 0 01-2-2V7a2 2 0 014 0v3a1 1 0 001 1h6a3.003 3.003 0 013 3v25a1 1 0 002 0V14a5.006 5.006 0 00-5-5zM24 23v38H8a3.003 3.003 0 01-3-3V23z"
            data-original="#422661"
          ></path>
          <path
            d="M59 23a1 1 0 000-2h-8a1 1 0 000 2zm5 0a1 1 0 000-2h-1a1 1 0 000 2zM9 27h12a1 1 0 000-2H9a1 1 0 000 2zm0 3h12a1 1 0 000-2H9a1 1 0 000 2zm0 3h12a1 1 0 000-2H9a1 1 0 000 2zm20 3h14a1 1 0 000-2H29a1 1 0 000 2zm0 3h13a1 1 0 000-2H29a1 1 0 000 2zM9 54h12a1 1 0 000-2H9a1 1 0 000 2zm0 3h12a1 1 0 000-2H9a1 1 0 000 2zm44-20a16 16 0 1016 16 16.018 16.018 0 00-16-16zm0 30a14 14 0 1114-14 14.016 14.016 0 01-14 14z"
            data-original="#422661"
          ></path>
          <path
            d="M58.707 44.293a1 1 0 00-1.414 0l-13 13A1 1 0 0044 58v3a1 1 0 001 1h3a1 1 0 00.707-.293l13-13a1 1 0 000-1.414zM47.586 60H46v-1.586l12-12L59.586 48z"
            data-original="#422661"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default RescheduleTodayIcon;